import React, { useState } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import Axios from "axios";
import ServerPath from "../../../../ServerPath";

//ACTIONS
import * as AccessModalActions from "../../../envStore/actions/accessModal";
import * as UserActions from "../../../../store/actions/user";

//STYLES
import * as FrontInterfaceStyles from "../styles/frontInterface";

function AuthSignIn() {
    const dispatch = useDispatch();

    const [data, setData] = useState({
        valids: {
            email: false,
            password: false
        },
        touched: {
            email: false,
            password: false
        },
        errorOnForm: false
    });
    const [message, setMessage] = useState("text");

    function handleOnChange(event) {
        const { id, value } = event.target;

        const valids = data.valids;

        let isValid = false;
        if (id == "email") {
            if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/gm.test(value)) {
                isValid = true;
            }
        } else {
            if (value != "") {
                isValid = true;
            }
        }

        valids[id] = isValid;

        const allTrue = Object.keys(data.valids).every(function (k) {
            return data.valids[k] === true;
        });

        setData((prevState) => {
            return { ...prevState, valids, errorOnForm: allTrue };
        });
    }

    function handleOnTouch(event) {
        const { id } = event.target;

        const touched = data.touched;
        touched[id] = true;

        setData((prevState) => {
            return { ...prevState, touched };
        });
    }

    function handleOpenForgotPassword() {
        dispatch(AccessModalActions.UpdateScreen("forgotPassword"));
    }

    function handleOpenRegister() {
        dispatch(AccessModalActions.UpdateScreen("register"));
    }

    function switchAllTouches() {
        const touches = Object.assign(...Object.keys(data.touched).map((k) => ({ [k]: true })));

        setData((prevState) => {
            return { ...prevState, touched: touches };
        });
    }

    function handleKeyPress(event) {
        if (event.key === "Enter") {
            handleSignInBtn();
        }
    }

    function handleSignInBtn() {
        if (!data.errorOnForm) {
            switchAllTouches();
        } else {
            const email = document.getElementById("email").value;
            const password = document.getElementById("password").value;

            const data = { email: email, password: password };
            Axios.post("/userLogin/auth/local/user", data)
                .then((res) => {
                    const data = res.data;
                    if (data.message === "Logged in successful") {
                        dispatch(UserActions.UpdateAuth(true));
                        dispatch(UserActions.UpdateID(data.user.id));
                        dispatch(UserActions.UpdateName(data.user.fullName));
                        dispatch(UserActions.UpdateEmail(data.user.email));
                        dispatch(UserActions.UpdateType(data.user.type));
                        dispatch(UserActions.UpdateRequestedPassword(data.user.requestedPassword == "true"));
                        setMessage("");
                        if (data.user.requestedPassword == "true") {
                            dispatch(AccessModalActions.UpdateScreen("changePassword"));
                        } else {
                            dispatch(AccessModalActions.SignInMethod());
                        }
                    } else {
                        setMessage(data.info);
                        if (data.info === "A Super Admin cannot sign into the front end") {
                            document.getElementById("username").value = "";
                            document.getElementById("password").value = "";
                        }
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    }

    function handleGoogleLink() {
        const host = ServerPath();
        console.log(host);
        window.location.href = `${host}/userLogin/auth/google`;
    }

    function handleFacebookLink() {
        const host = ServerPath();
        console.log(host);
        window.location.href = `${host}/userLogin/auth/facebook`;
    }

    function handleAppleLink() {
        const host = ServerPath();
        console.log(host);
        window.location.href = `${host}/userLogin/auth/apple`;
    }

    function handleLocalLoginLink() {
        dispatch(AccessModalActions.UpdateScreen("signIn_Email"));
    }

    return (
        <div>
            <Modal.Header closeButton>
                <Modal.Title>Sign In</Modal.Title>
            </Modal.Header>
            <Modal.Body style={FrontInterfaceStyles.signInBtn}>
                <Button variant={"danger"} onClick={handleGoogleLink}>
                    <i className="fab fa-google"></i> Log In With Google
                </Button>
                <br />
                <Button variant={"primary"} onClick={handleFacebookLink}>
                    <i className="fa-brands fa-facebook"></i> Log In With Facebook
                </Button>
                <br />
                <Button variant={"dark"} onClick={handleAppleLink}>
                    <i className="fa-brands fa-apple"></i> Log In With Apple
                </Button>
                <br />
                <Button variant={"link"} onClick={handleLocalLoginLink} style={{ textTransform: "capitalize" }}>
                    Log in with username and password instead
                </Button>
            </Modal.Body>
            <Modal.Footer></Modal.Footer>
        </div>
    );
}

export default AuthSignIn;
